/**
 * CreateReservationPage — route `/reservations/new` (PMS portal).
 *
 * SCRUM-337 (booking FE create-flow) — WIRED BODY. The route was
 * scaffolded in SCRUM-333 with its permission gate
 * (`booking.reservations.write`); SCRUM-337 replaces the honest
 * `NotConnectedYet` shell with the real create-reservation form
 * (`CreateReservationForm`): property picker, guest inline-create, stay
 * window, occupancy (adults + children), reservation type + heardAbout,
 * live quote preview, and the two submit paths (Create quote → QUO,
 * Confirm booking → BKD).
 *
 * The page body is thin: it composes the slice-internal
 * `CreateReservationForm` feature and renders it. All state, workflows,
 * data-fetching, and navigation live inside the feature. No
 * route-manifest, barrel, or permission-gate rework accompanies this
 * body swap.
 *
 * `icon="receipt"` was the nav-model glyph for the reservations slot;
 * the nav model is unchanged by this swap.
 */

import * as React from 'react';
import { CreateReservationForm } from '../features/CreateReservationForm.js';

export function CreateReservationPage(): React.ReactElement {
  return <CreateReservationForm />;
}
